import React from 'react';
import styles from './TextBadge.module.less';

const TextBadge = ({ text }: { text: string }) => (
  <div className={`${styles.custom_badge}`}>
    <p className={`${styles.custom_badge_text}`}>{text}</p>
  </div>
);

export default TextBadge;
